export {WarehouseModule} from './WarehouseModule';
